// extracted by mini-css-extract-plugin
export default {"onboardingBanner":"OnboardingBanner_onboardingBanner__Gj9Ib","bannerImage":"OnboardingBanner_bannerImage__W0wnc","bannerText":"OnboardingBanner_bannerText__mTVjI"};